<template>
  <div id="about">
    <TabBar />
    <div class="about_banner"></div>
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.about_banner {
  background: url("../../assets/images/yuanda_banner.png") no-repeat;
  background-position: center;
  height: 500px;
  position: relative;
  top: 90px;
  margin-bottom: 90px;
  min-width: 1200px;
}
</style>